import React from 'react';
import _ from 'lodash';
import { SanityObject, SanitySlug, useSanity } from '../../../lib/landingPage';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { Submenu as SubmenuRaw } from '../../../components/landingPage/Submenu';
import { Sections } from '../Sections';
import { observer } from 'mobx-react-lite';
import { PageProps } from '../../../pages/landingPage/Page';
import { Await } from '../../../components/Await';

export type SanitySubmenuSectionProps = {
    title: string;
    submenu: {
        slug: string;
        title: string;
    }[];
};

export type SubmenuProps = {
    slug: SanitySlug;
    submenu: SanitySubmenuSectionProps;
};

const SubmenuResolved = observer(
    ({ page }: { page: SanityObject<PageProps> }): JSX.Element => {
        return <Sections sections={page.sections} slug={page.slug} />;
    }
);

const AsyncSubmenu = observer(({ slug }: { slug: string }): JSX.Element => {
    const sanity = useSanity();
    return (
        <Await
            views={{
                page: sanity.asyncSubmenu(slug),
            }}
            resolved={SubmenuResolved}
        />
    );
});

export const Submenu = ({ slug, submenu }: SubmenuProps): JSX.Element => {
    const location = useLocation();
    const pathname = _.trim(location.pathname, '/');

    if (!pathname.includes('/')) {
        const search =
            typeof window !== 'undefined' ? window.location.search : '';
        return (
            <Redirect
                to={`/${slug.current}/${submenu.submenu[0].slug}${search}`}
            />
        );
    }

    return (
        <>
            <SubmenuRaw
                title={submenu.title}
                submenu={submenu.submenu}
                slug={slug.current}
                selected={pathname.split('/')[1]}
            />
            {submenu.submenu.map(p => (
                <Route path={`/${slug.current}/${p.slug}`} key={p.slug}>
                    <AsyncSubmenu slug={p.slug} />
                </Route>
            ))}
        </>
    );
};
